export default __webpack_public_path__ + "static/slider-la-b183ac61cadaee1f32220268fa44df5f.avif";